import React from 'react';

interface LoaderProps {
    isLoading: boolean;
    isPositionRelative?: boolean;
}

const Loader = (props: LoaderProps) => {
    const { isLoading, isPositionRelative } = props;
   
    if(isLoading) {
        return (
            <div className="loader__loader">
                <div className={`loader__loader-item ${isPositionRelative ? 'loader__loader-item--relative' : ''}`}><span></span></div>
            </div>
        );
    }
    return null;
};

export default Loader;